import keyMirror from 'keymirror';

export default keyMirror({
  GET_PRODUCTS_REQUEST: null,
  GET_PRODUCTS_SUCCESS: null,
  GET_PRODUCTS_FAILURE: null,

  GET_PRODUCT_REQUEST: null,
  GET_PRODUCT_SUCCESS: null,
  GET_PRODUCT_FAILURE: null,

  POST_PRODUCT_REQUEST: null,
  POST_PRODUCT_SUCCESS: null,
  POST_PRODUCT_FAILURE: null,
});



// WEBPACK FOOTER //
// ./src/api/products/types.js